export default function calculateAmountUnapplied(payment) {
  const amountInCents = Math.round((payment?.amount ?? 0) * 100);
  const totalPaidInCents = Math.round((payment?._total?.total_paid ?? 0) * 100);

  const valueInCents = amountInCents - totalPaidInCents;

  const valueInDollars = valueInCents / 100;

  return valueInDollars;
}
